
export const routeModules = [["app/home/home_page.tsx"],["app/home/test_page.tsx"],["app/home/home_page.tsx"],["app/gallery/gallery_page.tsx"],["app/gallery/gallery_page.tsx"],["app/resume/resume_page.tsx"]];
export const routes = [{
  path: "/",
  getComponent: async () => {
    const module = await import("./home/home_page.tsx");
    return module.HomePage;
  }
},{
  path: "/test/{id}",
  getComponent: async () => {
    const module = await import("./home/test_page.tsx");
    return module.TestPage;
  }
},{
  path: "/gallery/featured/{selectedImageId}",
  getComponent: async () => {
    const module = await import("./home/home_page.tsx");
    return module.HomePage;
  }
},{
  path: "/gallery/{galleryId}",
  getComponent: async () => {
    const module = await import("./gallery/gallery_page.tsx");
    return module.GalleryPage;
  }
},{
  path: "/gallery/{galleryId}/{selectedImageId}",
  getComponent: async () => {
    const module = await import("./gallery/gallery_page.tsx");
    return module.GalleryPage;
  }
},{
  path: "/resume",
  getComponent: async () => {
    const module = await import("./resume/resume_page.tsx");
    return module.ResumePage;
  }
}];
        